import React, { useState ,useEffect} from 'react';
import Table from '../common/Table';
import { withStyles } from '@material-ui/core/styles';
import tableConfig, { data } from './config';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Ratings from '../common/Rating';
import Type from '../common/Types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ReviewsAndRatings from '../ReviewsAndRatings';
import { Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { useParams} from "react-router-dom";
import { getFoodItemDetailsById} from '../../actions/fooditems';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import Loader from '../common/Loader';
import Button from '../common/Button';

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ChefAndRestaurantProfile = (props) => {
  const classes = props.classes;
  const history = useHistory();
  let config = tableConfig(props);
  const params  = useParams();
  let dishId = params.id;
  const [itemdet, setItemDet] = useState([]);
  const [timigs, setTimings] = useState([]);
  const [areacodes, setAreacodes] = useState([]);
  const [tags, setTags] = useState([]);
  const [deliveryopt, setDeliveryopt] = useState([]);
  const [itemImage, setItemImage] = useState("");
  const [msg, setMsg] = useState("");
  const [msgstatus, setMsgStatus] = useState("");
  useEffect(()=>{
     getFoodItemDetailsById(dishId).then((response)=>{
     //console.log(response.data.details);
      setMsgStatus(response.data.status);
      setMsg(response.data.desc);
      setItemImage(response.data.details.images[0].imageUrl);
      setItemDet(response.data.details === null ? '' : response.data.details);
      setTimings(response.data.details.times === null ? '' : response.data.details.times);
      setAreacodes(response.data.details.pinCodes === null ? '' : response.data.details.pinCodes);
      setTags(response.data.details.tags === null ? '' : response.data.details.tags);
      setDeliveryopt(response.data.details.deliveryOptions === null ? '' : response.data.details.deliveryOptions);
    })
   }, []);

  const onView = () => { console.log("View") }
  const onDelete = () => { console.log("Delete") }

  const [state, setState] = useState({
    users: true,
    chefs: false,
    restaurants: false,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
 
  return (
    <div style={{ width: '100%' }}>
    <Box display="flex" p={1}  className="mb-3" justifyContent="flex-end">
    <Button onClick={() => {history.goBack();}} size="small" label="Back"></Button>
    </Box>
  <React.Fragment>
    {msgstatus ==="error" && <div className={classes.errorwrap}>
      <h1>{msg}</h1></div>}
     {(msgstatus!="error" && itemdet.length===0) && <Loader/> }
  <div className={classes.wrap}>
    <div className={classes.section1}>
    {itemdet!="" &&
      <Card className={classes.root}>
        <CardContent classes={{ root: classes.contentWrapper }}>
          <div className={classes.cardContent}>
          <img src={itemImage} className={classes.profile} />
            <div className={classes.profileHeader}>
              <h2 className="w-100 text-center"> <strong>{itemdet.itemName ? itemdet.itemName : ""}</strong> </h2>
              <label className="w-100 themeColor mt-2 text-center"> <strong> {itemdet.cuisineName ? itemdet.cuisineName : ""} </strong> </label>
            </div>
            <div className={classes.category}>
            <div className="mb-2"> {itemdet.categoryName ? itemdet.categoryName : ""} - {itemdet.subCategoryName ? itemdet.subCategoryName : ""} </div>
            <div className="mb-2 flex justify-content-between"> {itemdet.maxDishesPerDay ? itemdet.maxDishesPerDay : ""} dishes in a day <Type color={( itemdet.foodType === "Veg") ? 'green' : 'red'}/> </div>
            <div className="mb-2 flex justify-content-between fullWidth">
                <Ratings rating={itemdet.rating ? itemdet.rating : "0"} ratingCount={5}/>
            </div>
            <div className="mb-2 flex justify-content-between fullWidth">
                <Typography color="primary">{( itemdet.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{itemdet.price ? itemdet.price : ""} </Typography>
                <Typography color="secondary" variant="body2"> {itemdet.weight ? itemdet.weight : ""} </Typography>
            </div>
            </div>
          </div>
           <div className={classes.profileDetails}>
          <div className={classes.item1}>
            {tags.map((s, t) => {
            return (
              <Chip key={s.mappingId} size="small" label={s.tagName} variant="outlined" />
             );
            })}
            </div>
            
           {/*  <div className={classes.item1}>
              <label> Delivery preference </label>
              <div className={classes.users}>
              {deliveryopt.map((s, t) => {
            return (
               <FormControlLabel key={s.optionId}
                  classes={{ label: classes.checkBoxLabel, root: classes.labelRoot }}
                  control={<GreenCheckbox size="small" checked={state.users} onChange={handleChange} name={s.optionName} />}
                  label={s.optionName}
                />
             );
            })}
             
              </div>
            </div> */}
           <div className={classes.item1}>
            <label> Time Availability </label>
            {timigs.map((s, t) => {
            return (
              <div>
               <label key={s.mappingId}>
               <strong>{s.time}</strong>                 
              </label>
               </div>
             );
            })}
            </div>
            <div className={classes.item1}>
            <label>Available Areas </label>
            {areacodes.map((s, t) => {
            return (
              <div>
               <label key={s.mappingId}>
               <strong>{s.pinCode}</strong>                 
              </label>
               </div>
             );
            })}
            </div>
             <div className={classes.item1}>
              <label> Description </label>
              <label> <strong>{itemdet.description ? itemdet.description : ""}</strong> </label>
            </div>
          </div>
        </CardContent>
      </Card>
   }
  </div>
    <div className={classes.section2}>
    {params.id!="" && itemdet!="" &&
      <ReviewsAndRatings  id = {params.id} totalrating = {itemdet.rating} rating={[itemdet.fiveRating,itemdet.fourRating,itemdet.threeRating,itemdet.twoRating,itemdet.oneRating]} revfun = "itemId"/>
     }
    </div>

  </div>
  </React.Fragment>
   </div>
  )
};

export default ChefAndRestaurantProfile;
